import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PlayerLogo3DJerseyBack } from '../../../../../widgets/components/sm/views/playerLogo/SMPlayerLogo';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';

const Header = styled.div`
    display: flex;
    align-items: center;
    margin: 0 0 30px;

    h2 {
        margin: 0;

        font-size: 3em;
    }
`;

const Ul = styled.ul``;

const Li = styled.li`
    ${({ active }) => active && ``};
`;

const BtnWrapper = styled.div`
    display: flex;
    align-items: center;

    > * {
        margin-right: 10px;
    }
`;

const imageWrapStyle = { marginRight: 10, position: 'relative' };

// TODO: ADD: Displays name, age, current club, national team, load team (if available)
function PlayerHeader({ playerId = {}, player = {}, tournamentId = '', seasonId = '', teamId = '' }) {
    return (
        <div>
            <Header>
                <PlayerLogo3DJerseyBack
                    playerId={player.id}
                    teamId={player.team && player.team.id}
                    seasonId={seasonId}
                    width={100}
                    number={player.team && ~~player.team.number}
                    display="3d_jersey"
                    size="large"
                    imageWrapStyle={imageWrapStyle}
                />
                <h2>{player.name}</h2>
                {player.nationalTeam && (
                    <Ul>
                        <Li
                            active={location.pathname.includes(
                                `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${
                                    player.team.id
                                }/squad/players/${playerId}/home`
                            )}
                        >
                            <Link
                                to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${
                                    player.team.id
                                }/squad/players/${playerId}`}
                            >
                                {player.team.name}
                            </Link>
                        </Li>
                        <Li
                            active={location.pathname.includes(
                                `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${
                                    player.nationalTeam.id
                                }/squad/players/${playerId}/home`
                            )}
                        >
                            <Link
                                to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${
                                    player.nationalTeam.id
                                }/squad/players/${playerId}`}
                            >
                                {player.nationalTeam.name}
                            </Link>
                        </Li>
                    </Ul>
                )}
            </Header>
            <BtnWrapper>
                <Link
                    to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad/players/${playerId}/home`}
                >
                    <RaisedButton
                        label="Home"
                        primary={location.pathname.includes(
                            `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad/players/${playerId}/home`
                        )}
                    />
                </Link>
                <Link
                    to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad/players/${playerId}/compare`}
                >
                    <RaisedButton
                        label="compare"
                        primary={location.pathname.includes(
                            `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad/players/${playerId}/compare`
                        )}
                    />
                </Link>
            </BtnWrapper>
        </div>
    );
}

PlayerHeader.propTypes = {
    playerId: PropTypes.string.isRequired,
    player: PropTypes.object.isRequired,
    tournamentId: PropTypes.string.isRequired,
    seasonId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired
};

export default PlayerHeader;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/PlayerHeader.js
 **/